import Alpine from "alpinejs";

Alpine.data('navMobile', (initialState = false) => ({
    shown: initialState,

    y: 0,

    inner: null,

    init() {
        window.addEventListener('scroll', () => {
            this.y = window.pageYOffset;
        });
    },

    show() {
        this.shown = true;

        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.y}px`;
    },

    hide() {
        this.shown = false;
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
}));